module.exports = __webpack_public_path__ + "img/conectar-white.6b7dea54.png";